<template>
	<div id="not-found" class="content container">    
		<h3>Uh, oh!</h3>
		<p>Looks like you took a wrong turn! The page you were looking for doesn't exist.</p>
		<img src="/assets/images/logo-notfound.png">
	</div>
</template>

<script>
export default {
	name: 'NotFoundView'
}
</script>

<style scoped>
#not-found {
	text-align: center;
}

#not-found img {
	width: 50%;
}
</style>